import React, { useEffect, useState } from 'react';
import productService from '../../../../../services/productService';
import categoryService from '../../../../../services/categoryService';
import GeneralIcon from '../../../../../assets';
import VariantModal from "./VariantModal";
import VariantItem from "./VariantItem";
import EmptyStateVariants from "./EmptyStateVariants";
import AdicionarProdutoFinalStep from "./AdicionarProdutoFinalStep";




export default function AdicionarProduto({ product, onClose }) {
  const [step, setStep] = useState(1);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [category, setCategory] = useState('');
  const [customCode, setCustomCode] = useState('');
  const [properties, setProperties] = useState([]); // {name, value}
  const [specs, setSpecs] = useState([]);
  const [cnaeList, setCnaeList] = useState([]);
  const [selectedCnae, setSelectedCnae] = useState('');
  const [categoryOptions, setCategoryOptions] = useState([]);

  const [variants, setVariants] = useState([]);
  const [showVariantModal, setShowVariantModal] = useState(false);

  const [editingVariant, setEditingVariant] = useState(null); // armazena a variante em edição

  const [variantToEdit, setVariantToEdit] = useState(null); // armazena a variante em edição

  // se houver produto para editar, preenche os campos
  useEffect(() => {
  if (product) {
    setTitle(product.title || '');
    setDescription(product.description || '');
    setCategory(product.category || '');
    setCustomCode(product.customCode || '');
    setProperties(product.properties || []);
    setSpecs(product.specs || []);
    setSelectedCnae(product.cnae || '');
    setVariants(product.variants || []);
  }
}, [product]);


  useEffect(() => {
    let mounted = true;
    productService.fetchCNAEs().then(res => {
      if (!mounted) return;
      // expect array of CNAEs
      setCnaeList(res || []);
    }).catch(() => {});
    // Load local categories for Mercadoria
    categoryService.fetchCategories('Mercadoria').then(res => {
      if (!mounted) return;
      setCategoryOptions(Array.isArray(res) ? res : []);
    }).catch(() => {});
    return () => { mounted = false; };
  }, []);

  // prevent background scroll while modal is open
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = prev; };
  }, []);

  function addProperty() {
  setProperties(prev => [...prev, { name: '', values: [] }]);
}

  function addSpec() {
  setSpecs(prev => [...prev, { name: '', value: '' }]);
}

  function onProceed() {
    // basic validation could go here
    setStep(2);
  }

  function onAddVariant(variant) {
  if (editingVariant !== null) {
    // substituir variante editada
    setVariants(prev => prev.map((v, idx) => idx === editingVariant ? variant : v));
    setEditingVariant(null);
  } else {
    // adicionar nova
    setVariants(prev => [...prev, variant]);
  }
  setShowVariantModal(false);
}

    //exclusion of property
  function removeProperty(index) {
  setProperties(prev => prev.filter((_, i) => i !== index));
}
  //exclusion of spec
function removeSpec(index) {
  setSpecs(prev => prev.filter((_, i) => i !== index));
}


  return (
    <div className="fixed inset-0 bg-black/40 z-40 overflow-auto">
      <div className="min-h-screen flex items-start justify-center p-6">
        <div className="bg-white rounded-lg w-full max-w-2xl p-6 max-h-[90vh] overflow-y-auto" style={{ WebkitOverflowScrolling: 'touch' }}>
        <div className="flex items-center gap-3 mb-4">
          <button onClick={() => { if (step === 1) onClose && onClose(); else setStep(1); }} className="p-2 rounded hover:bg-gray-100">←</button>
          <h3 className="text-lg font-semibold">Adicionar mercadoria</h3>
        </div>

        {step === 1 ? (
          <div className="space-y-4">
            <div>
              <label className=" font-medium">Título do produto*</label>
              <input className="w-full border rounded px-3 py-2 mt-1 focus:ring-2 focus:ring-purple-500 focus:outline-none text-gray-800" value={title} onChange={e => setTitle(e.target.value)} placeholder='Linguíça Toscana Aurora' />
            </div>
            <div>
              <label className=" font-medium">Descrição geral</label>
              <textarea className="w-full border rounded px-3 py-2 mt-1 focus:ring-2 focus:ring-purple-500 focus:outline-none text-gray-800" value={description} onChange={e => setDescription(e.target.value)} placeholder='Carne deliciosa para churrasco' />
            </div>
            <div>
              <label className=" font-medium">Categoria*</label>
              <select className="w-full bg-gray-50 border rounded px-3 py-2 mt-1 text-gray-800" value={category} onChange={e => setCategory(e.target.value)}>
                <option value="">Nenhuma</option>
                {categoryOptions.map(c => (
                  <option key={c.id} value={c.name}>{c.name}</option>
                ))}
              </select>
            </div>
            <div>
              <label className=" font-medium">Código personalizado</label>
              <input className="w-full border rounded px-3 py-2 mt-1 focus:ring-2 focus:ring-purple-500 focus:outline-none text-gray-800" value={customCode} onChange={e => setCustomCode(e.target.value)} placeholder='LING12'/>
            </div>
          

            <div>
             <div className="flex items-center justify-between">
              <div className="font-semibold text-lg text-gray-800">Propriedades</div>
            </div>
              <div className='text-xs mb-3'> Uma propriedade se refere ao que diferencia as variantes de um produto. Um exemplo é a “cor”.</div>
            <div>
              <button 
               onClick={addProperty} 
                className=" items-center text-sm text-white bg-purple-600 px-4 py-2 rounded-md hover:bg-purple-700 transition duration-200"
              >
                 Adicionar uma propriedade
                </button>
                </div>
              <div className="mt-4 space-y-4">
  {properties.map((p, idx) => (
    <div key={idx} className="flex gap-2 items-center">
      
      {/* Nome da propriedade */}
      <input
        placeholder="Nome"
        className="flex-1 border rounded-lg px-3 py-2 border-gray-300 focus:ring-2 focus:ring-purple-500 focus:outline-none"
        value={p.name}
        onChange={e => setProperties(prev => {
          const cp = [...prev];
          cp[idx].name = e.target.value;
          return cp;
        })}
      />

      {/* Valores da propriedade, separados por vírgula */}
      <input
        placeholder="Valores (separados por vírgula)"
        className="flex-1 border rounded-lg px-3 py-2 border-gray-300 focus:ring-2 focus:ring-purple-500 focus:outline-none"
        value={p.values.join(', ')}
        onChange={e => setProperties(prev => {
          const cp = [...prev];
          cp[idx].values = e.target.value.split(',').map(v => v.trim());
          return cp;
        })}
      />

      {/* Botão de remover */}
      <button onClick={() => removeProperty(idx)} className="text-red-500 text-xs"> <GeneralIcon iconName="lixeira" className="h-5 w-5" /></button>
    </div>
  ))}
</div>

         </div>

              <div>
               <div className="flex items-center justify-between">
                 <div className="font-semibold text-lg text-gray-800">Especificações genéricas</div>
                 </div>
                   <div className='text-xs mb-3'> Uma especificação genérica estará presente em todas as variantes do produto.</div>
                 <div>
                 <button 
  onClick={addSpec} 
  className="text-sm text-white bg-purple-600 px-4 py-2 rounded-md hover:bg-purple-700 transition duration-200"
>
  Adicionar uma especificação
</button>
</div>
                 
                <div className="mt-4 space-y-4">
  {specs.map((s, idx) => (
    <div key={idx} className="flex gap-2 items-center">
      <input
        placeholder="Nome"
        className="flex-1 border rounded-lg px-3 py-2 border-gray-300 focus:ring-2 focus:ring-purple-500 focus:outline-none"
        value={s.name}
        onChange={e => setSpecs(prev => {
          const cp = [...prev];
          cp[idx].name = e.target.value;
          return cp;
        })}
      />
      <input
        placeholder="Valores (separados por vírgula)"
        className="flex-1 border rounded-lg px-3 py-2 border-gray-300 focus:ring-2 focus:ring-purple-500 focus:outline-none"
        value={s.value}
        onChange={e => setSpecs(prev => {
          const cp = [...prev];
          cp[idx].value = e.target.value;
          return cp;
        })}
      />
      <button onClick={() => removeSpec(idx)} className="text-red-500 text-xs"> <GeneralIcon iconName="lixeira" className="h-5 w-5" /></button>
    </div>
  ))}
</div>
              </div>

            <div>
              <div className="font-medium mt-10">Fiscal</div>
               <div className='text-xs mb-3'> Especifique qual é a área de atuação da sua empresa que mais se aproxima do produto que você está adicionando.</div>
              <div className="mt-2">
                <label className="text-xs">CNAE</label>
                <select className="w-full border rounded px-3 py-2 mt-1" value={selectedCnae} onChange={e => setSelectedCnae(e.target.value)}>
                  <option value="">Selecionar</option>
                  {cnaeList.map(c => <option key={c.code || c.id} value={c.code || c.id}>{(c.code ? c.code + ' - ' : '') + (c.description || c.name || c.title)}</option>)}
                </select>
              </div>
            </div>

            <div className="mt-4 flex gap-2">
              <button onClick={() => onClose && onClose()} className="flex-1 py-3 rounded border">Cancelar</button>
              <button onClick={() => setStep(2)} className="flex-1 py-3 rounded bg-purple-600 text-white">Prosseguir</button>
            </div>
          </div>
        ) : step === 2 ? (

          // variantes step
          <div>
            <div className="mb-3">Variantes</div>
            <div className="mt-4">
  {variants.length === 0 ? (
    <EmptyStateVariants />
  ) : (
    <div className="space-y-3">
     {variants.map((v, idx) => (
  <VariantItem
    key={idx}
    v={v}
    onEdit={() => {
      setEditingVariant(idx);
      setShowVariantModal(true);
      setVariantToEdit(v); // cria um estado extra para a variante atual
    }}
    onDelete={() => setVariants(prev => prev.filter((_, i) => i !== idx))}
  />
))}


    </div>
  )}
</div>


            <div className="mt-6">
              <button onClick={() => setShowVariantModal(true)} className="w-full py-3 rounded bg-purple-600 text-white">+ Adicionar uma nova variante</button>
            </div>

            <div className="mt-4">
              <button 
  onClick={() => setStep(3)} 
  className="w-full py-3 rounded bg-purple-700 text-white"
>
  Prosseguir
</button>

            </div>
          </div>
        ) : (
  // STEP 3 — FINAL SCREEN
  <AdicionarProdutoFinalStep
    product={product}
    variants={variants}
    onBack={() => setStep(2)}
    onFinish={async (defaultVariantIdx, linkedDocs) => {
      const payload = {
        title,
        description,
        category,
        customCode,
        properties,
        specs,
        cnae: selectedCnae,
        variants,
        defaultVariantIndex: defaultVariantIdx,
        linkedDocuments: linkedDocs.map(d => d.id)
      };

      try {
        if (product) {
          await productService.updateProduct(product.id, payload);
          alert('Produto atualizado com sucesso!');
        } else {
          await productService.createProduct(payload);
          alert('Produto criado com sucesso!');
        }
        onClose && onClose();
      } catch (err) {
        console.error('Save error:', err);
        alert('Erro ao salvar produto: ' + err.message);
      }
    }}
  />
)}

        
        

     {showVariantModal && (
  <VariantModal
    onClose={() => {
      setShowVariantModal(false);
      setEditingVariant(null);
      setVariantToEdit(null);
    }}
    onAdd={onAddVariant}
    properties={properties}
    specs={specs}
    variant={variantToEdit} // agora sempre funciona
  />
)}

      </div>
      </div>
    </div>
  );
}

